/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 * 
 * Unauthorized copying of the code in this file, completely or partially, 
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 * 
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/

import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Toast.css";

// Customize toast notification
const Toast = () => {
  return (
    <ToastContainer
      autoClose={3000}
      hideProgressBar={false}
      bodyClassName="ToastBody"
    />
  );
};

export default Toast;
